<template>
  <div class="chat-page">
    <ChatInterface :conversationId="parseInt(id)" />
  </div>
</template>

<script>
import ChatInterface from "@/components/ChatInterface.vue";

export default {
  name: "ChatPage",
  components: {
    ChatInterface,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.chat-page {
  display: flex;
  height: calc(100vh - 60px);
  width: 100%;
  overflow: hidden;
  background-color: white;
}
</style>
